<template>
  <div class="box border-box" :style="{'border': (border ? '':'none')}">
    <div ref="locationList" class="scroll-wrap" ui-jp="mCustomScrollbar" data-mcs-theme="minimal-dark" ui-options="{theme:'minimal-dark', height: '200px'}" :style="[{'max-height': height + 'px'}, {'height': height + 'px'}, {'overflow-y': 'scroll'}]">
      <div class="box-body">
        <!--<div v-for="item in locations">-->
          <!--<label class="md-check">-->
            <!--<input type="checkbox">-->
            <!--<i class="blue"></i> <span><i class="success-mark"></i> 테스트</span>-->
          <!--</label>-->
        <!--</div>-->
        <div v-for="(item, index) in locations" :key="index" :style="{color: fontColor(item)}">
          <label class="md-check" v-if="!item.hide">
            <input type="checkbox" v-model="item.checked" @change="changeHandler(item)" :disabled="disabled(item)">
            <i class="blue"></i>
            <span>
              <i :class="[icon(item), item.checked? 'success-mark' :'']"></i>
              {{item.name}}, {{item.reserved}}
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LocationBase from '@/components/common/locationBase'
export default {
  mixins: [LocationBase],
  props: {
    height: { type: Number, default: function(){ return 170}},
    staticSource: {
      type: Array,
      default: () => null
    },
    dataSource: {
      type: String,
      default: () => "[]"
    },

    editMode: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    border: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
    disableInitData: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
  },
  data(){
    return {
      value:null,
      selectedItems: [],
      selectedItem: null,
      formEdit: false,
      locations: []
    }
  },
  mounted(){
    this.formEdit = this.editMode;
    this.$nextTick(() => {
      $(".scroll-wrap").mCustomScrollbar({
          axis:"y" // horizontal scrollbar
      })
    })
  },
  watch:{
    formEdit(newVal){
      this.update();
    },
    staticSource(nVal, oVal){
      this.setRequestLocation();
    }
  },
  computed: {
    disabled(){
      return(item) =>{
        if(!this.formEdit)
          return true;
        if(item.reserved)
          return false;
        else
          return true;
      }
    },
    checkedStyle(){
      return (item) =>{
        if(item.checked)
          return 'success-mark';
        else
          return '';
      }
    },
    fontColor(){
      return(item) =>{
        if(item.isLock){
          return '#f84d3a'
        }
        if(!item.reserved){
          return '#999'
        }
        return '#333';
      }
    },
    icon() {
      return(item) =>{
        if(item.isLock){
          return 'icon-security'
        }

        if(item.reserved){
          return 'icon-complete'
        }
        if(!item.reserved){
          return 'icon-fail'
        }
        return 'icon-complate';
      }
    },

    getLocationNameById() {
      return (idcId) =>{
        this.location.forEach()
      }
    },
    async getRequestLocation(){
      var that = this;
      var parseIdc = JSON.parse(this.dataSource);
      var trunkList = await this.trunkList();
      var locationList = trunkList;
      if(this.disableInitData){
        locationList.forEach(x=>{
          x.hide = true;
        })
      }
      console.log(this.staticSource);
      if(this.staticSource){
        this.staticSource.forEach(x =>{
          that.bindItem(locationList, x);
        })
        //this.staticSource = locationList;
        console.log(locationList);
        return locationList;
      }
      if(parseIdc){
        parseIdc.forEach(x => {
          var rooms = [];
          x.forEach((y)=>{
            let arr = [];
            that.makeOjectFindKey(arr, that.location, y).then(() => {
              var o = {id: y, name: arr[0].locationName, code: arr[0].locationCode}
              rooms.push(o);
            });
          });

          rooms.reverse();
          var location = {id: this.uuidv4(), name:_.map(rooms, x => x.name).join(' > '), reserved: true, checked: false, reserved: true, rooms: rooms, key: _.map(rooms, x => x.code).join('')}
          this.bindItem(locationList, location);
          //locationList.push(location);
        });
      }
      this.$forceUpdate();

      return locationList;
    }
  },
  created() {
    this.setRequestLocation();
  },
  methods: {
    async setRequestLocation(){
      var that = this;
      var parseIdc = JSON.parse(this.dataSource);
      var trunkList = await this.trunkList();
      var locationList = trunkList;
      if(this.disableInitData){
        locationList.forEach(x=>{
          x.hide = true;
        })
      }
      if(this.staticSource){
        this.staticSource.forEach(x =>{
          that.bindItem(locationList, x);
        })
        //this.staticSource = locationList;
        this.locations = locationList;
        return locationList;
      }
      if(parseIdc){
        parseIdc.forEach(x => {
          var rooms = [];
          x.forEach((y)=>{
            let arr = [];
            that.makeOjectFindKey(arr, that.location, y).then(() => {
              var o = {id: y, name: arr[0].locationName, code: arr[0].locationCode}
              rooms.push(o);
            });
          });

          rooms.reverse();
          var location = {id: this.uuidv4(), name:_.map(rooms, x => x.name).join(' > '), reserved: true, checked: false, reserved: true, rooms: rooms, key: _.map(rooms, x => x.code).join('')}
          this.bindItem(locationList, location);
          //locationList.push(location);
        });
      }
      this.$forceUpdate();

      return locationList;
    },
    bindItem(trunkList, item){
      if(trunkList){

        var has = trunkList.filter((x)=>{
          return x.key == item.key
        });
        if(has.length > 0){
          has[0].checked = item.checked;
          has[0].reserved = item.reserved;
        }
      }
    },
    appendData(list){

      Object.assign(this.getRequestLocation, list)
      this.$forceUpdate();
    },
    removeData(list){
      var result = [];
      list.forEach(x=>{
        this.getRequestLocation.forEach(y => {
          if(y.name != x.name){
            result.push(y);
          }
        })
      })
      this.getRequestLocation = result;
      this.$forceUpdate();
    },

    changeHandler(item){
      var that = this;
      this.$nextTick(() => {
        this.value = item;
        this.selectedItem = this.value;

        this.selectedItems = this.getRequestLocation.filter(x=> x.checked)
        this.$emit("change", this.getRequestLocation)
        this.$emit("input",this.value);
        this.$forceUpdate();
      });

    },
    async update(){
      this.selectedItems = (await this.getRequestLocation).filter(x=> x.checked)
      this.$forceUpdate();
    },
    updateInput: function(event) {
      var updatedText = event.target.value;
      this.value = updatedText;
      this.$emit('input', event.target.value);
    },
    confirmInput(event) {
      //this.$parent.$emit("confirmInput");
      this.$emit("confirmInput");
      this.formEdit = false;
    },
    cancelInput(event) {
      //this.$parent.$emit("cancelInput");
      this.$emit('input', this.tempData);
      this.formEdit = false;
    },
  }
}
</script>

<style>

</style>
